<script>
  export let aspectRatio = 1
</script>

<div class="squared" style="--aspect-ratio: {aspectRatio * 100}%">
  <div class="squared-inner">
    <slot />
  </div>
</div>

<style>
  .squared {
    display: block;
    padding-bottom: var(--aspect-ratio);
    height: 0;
    position: relative;
    width: 100%;
  }

  .squared-inner {
    position: absolute;
    width: 100%;
    height: 100%;
  }
</style>